import { searchG2QueryParams } from ".";
import { stripURL } from "./stripURL";
import { blogs } from "./globalObj";

/* * * * * * * * * * * * * * * * *
 * Pagination
 * javascript page navigation
 * * * * * * * * * * * * * * * * */
// export const Pagination = {
//     code: '',
//     size: 0,
//     page: 1,
//     step: 3,
//     e: (undefined as any),
//     innerHTML: "",

//     // --------------------
//     // Utility
//     // --------------------

//     // converting initialize data
//     Extend: function(data:any) {
//         data = data || {};
//         Pagination.size = data.size || 0;
//         Pagination.page = data.page || 1;
//         Pagination.step = data.step || 3;
//     },

//     // add pages by number (from [s] to [f])
//     Add: function(s:any, f:any) {
//         for (var i = s; i < f; i++) {
//             Pagination.code += `<li class="page-item"><a id="pagination${i}" href="${stripURL(window.location.href)}/page/${i}" class="page-link">${i}</a></li>`;
//         }
//     },

//     // add last page with separator
//     Last: function() {
//         Pagination.code += `<li class="page-item">…</li><li class="page-item"><a id="paginationLast" href="${stripURL(window.location.href)}/page/${Pagination.size}" class="page-link">${Pagination.size}</a></li>`;
//     },

//     // add first page with separator
//     First: function() {
//         Pagination.code += `<li class="page-item"><a id="pagination1" href="${stripURL(window.location.href)}/page/1" class="page-link">1</a></li><li class="page-item">…</li>`;
//     },
//     // --------------------
//     // Handlers
//     // --------------------

//     // change page
//     Click: function() {
//         Pagination.page = +this.innerHTML;
//         Pagination.Start();
//     },

//     // previous page
//     Prev: function() {
//         Pagination.page--;
//         if (Pagination.page < 1) {
//             Pagination.page = 1;
//         }
//         Pagination.Start();
//     },

//     // next page
//     Next: function() {
//         Pagination.page++;
//         if (Pagination.page > Pagination.size) {
//             Pagination.page = Pagination.size;
//         }
//         Pagination.Start();
//     },
//     // --------------------
//     // Script
//     // --------------------

//     // binding pages
//     Bind: function() {
//         var a = Pagination.e.getElementsByTagName('a');
//         for (var i = 0; i < a.length; i++) {
//             if (+a[i].innerHTML == Pagination.page) {
//                 a[i].parentNode.classList.add('blackColor');
//             }
//         }
//     },
//     // write pagination
//     Finish: function() {
//         Pagination.e.innerHTML = Pagination.code;
//         Pagination.code = '';
//         Pagination.Bind();
//     },
//     // find pagination type
//     Start: function() {
//         if (Pagination.size < Pagination.step * 2 + 6) {
//             Pagination.Add(1, Pagination.size + 1);
//         }
//         else if (Pagination.page < Pagination.step * 2 + 1) {
//             Pagination.Add(1, Pagination.step * 2 + 4);
//             Pagination.Last();
//         }
//         else if (Pagination.page > Pagination.size - Pagination.step * 2) {
//             Pagination.First();
//             Pagination.Add(Pagination.size - Pagination.step * 2 - 2, Pagination.size + 1);
//         }
//         else {
//             Pagination.First();
//             Pagination.Add(Pagination.page - Pagination.step, Pagination.page + Pagination.step + 1);
//             Pagination.Last();
//         }
//         Pagination.Finish();
//     },
//     // --------------------
//     // Initialization
//     // --------------------

//     // binding buttons
//     Buttons: function(e:any) {
//         var nav = e.getElementsByTagName('a');
//         nav[0].addEventListener('click', Pagination.Prev, false);
//         nav[1].addEventListener('click', Pagination.Next, false);
//     },

//     // create skeleton
//     Create: function(e:any) {
//         const nextPage = Pagination.page == Pagination.size ? '#' : `${stripURL(window.location.href)}/page/${parseInt(Pagination.page) + 1}`;
//         const prevPage = Pagination.page == 1 ? '#' : `${stripURL(window.location.href)}/page/${parseInt(Pagination.page) - 1}`;
//         var html = [
//             `<li class="page-item backLink"><a id="paginationBack" href="${prevPage}" class="page-link ${prevPage == '#' ? 'pagination-disable-back blackColor' : 'pagination-enable-back' }">Back</a></li>`, // previous button
//             '<span></span>',  // pagination container
//             `<li class="page-item nextLink"><a id="paginationNext" href="${nextPage}" class="page-link ${nextPage == '#' ? 'pagination-disable-next blackColor' : 'pagination-enable-next' }">Next</a></li>`  // next button
//         ];
//         e.innerHTML = html.join('');
//         Pagination.e = e.getElementsByTagName('span')[0];
//         // Pagination.Buttons(e);
//     },

//     // init
//     Init: function(e:any, data:any) {
//         Pagination.Extend(data);
//         Pagination.Create(e);
//         Pagination.Start();
//     }
// };


///
const Pagination =
{
    page: 1,
    size: 0,
    step: 2,
    html: '',
    rem: 0,
    index: 0,
};
export function loadPagination( blogCount: any) {    
    var num = Math.ceil((blogCount) / 6);
    Pagination.size = num;
    Pagination.html = '';
    if (num > 1) {
        if (Pagination.size < Pagination.step * 2 + 3) {
            AddPagination(1, Pagination.size + 1);
        }
        else if (Pagination.page < Pagination.step * 2) {
            AddPagination(1, Pagination.step * 2 + 1);
            setLastPagination();
        }
        else if (Pagination.page > Pagination.size - Pagination.step * 2) {
            Pagination.html += '<li class="page-item"><a class="pagination-item text-sm" href="#"><span class="sr-only">page</span>1</a></li><li class="page-item"><a class="pagination-item text-sm expand-cursor"><span class="sr-only">Expand page</span>...</a></li>';
            AddPagination(Pagination.size - Pagination.step * 2, Pagination.size + 1);
        }
        else {
            Pagination.html += '<li class="page-item"><a class="pagination-item text-sm" href="#"><span class="sr-only">page</span>1</a></li><li class="page-item"><a class="pagination-item text-sm expand-cursor"><span class="sr-only">Expand page</span>...</a></li>'
            AddPagination(Pagination.page - 1, Pagination.page + Pagination.step);
            setLastPagination();
        }
        $('.pagination-section .page-numbers').html(Pagination.html);
        $('.pagination-section').removeClass('hidden');
    }
    else {
        $('.pagination-section').addClass('hidden');
    }
   
    setCurrentPage();
}
function setCurrentPage() {
    $('ul.page-numbers a').removeAttr('aria-current');
    $('ul.page-numbers a').each(function () {
        if ($(this).text() == 'page' + Pagination.page) {
            $(this).attr('aria-current', 'page');
        }
    })
    
    if (Pagination.page == 1) {
        $('.pagination').find('.first, .prev').addClass('disabled');
        $('.pagination').find('.next, .last').removeClass('disabled');
    }
    else if (Pagination.page == Pagination.size) {
        $('.pagination').find('.first, .prev').removeClass('disabled');
        $('.pagination').find('.next, .last').addClass('disabled');
    }
    else {
        $('.pagination').find('.first, .prev, .next, .last').removeClass('disabled');
    }
}
function setLastPagination() {
    Pagination.html += '<li class="page-item"><a class="pagination-item text-sm expand-cursor"><span class="sr-only">Expand page</span>...</a></li><li class="page-item"><a class="pagination-item text-sm" href="#"><span class="sr-only">page</span>' + Pagination.size + '</a></li>'; //<li class="page-item"><a class="pagination-item text-sm"><span class="sr-only">page</span>' + (Pagination.size - 1) + '</a></li>
}
function AddPagination(start:any, finish:any) {
    for (var i = start; i < finish; i++) {
        Pagination.html += '<li class="page-item"><a class="pagination-item text-sm" href="#"><span class="sr-only">page</span>' + i + '</a></li>';
    }
}

$(document).on('click', '.pagination-section .page-numbers a', function (e) {
    e.preventDefault();
    let just_text:any = $(this)
    Pagination.page = Number(just_text.justtext());
    appendQueryString();     
    loadPagination(blogs.count);
     // loadPhotosbyCategoryfromApi(category.id, Pagination.page);  
     window.sessionStorage.setItem('pageNumber', Pagination.page-1) 
     searchG2QueryParams(undefined,undefined);  
    scrollUp(); 
});
$(document).on('click', '.pagination-section .pagination .next', function (e) {
    e.preventDefault();
    if (Pagination.page < Pagination.size) {
        Pagination.page++;
        var liindex = $('ul.page-numbers li a[aria-current="page"]').parent().index();
        $('ul.page-numbers li:nth-child(' + (liindex + 2) + ') a').trigger('click');
    }
});
$(document).on('click', '.pagination-section .pagination .prev', function (e) {
    e.preventDefault();
    Pagination.page--;
    var liindex = $('ul.page-numbers li a[aria-current="page"]').parent().index();
    if (liindex == 1) {
        $('ul.page-numbers li:first-child a').trigger('click');
    }
    else {
        $('ul.page-numbers li:nth-child(' + (liindex) + ') a').trigger('click');
    }
    
});
$(document).on('click', '.pagination-section .pagination .first', function (e) {
    e.preventDefault();
    Pagination.page = 1;
    $('ul.page-numbers li:first-child a').trigger('click');
});
$(document).on('click', '.pagination-section .pagination .last', function (e) {
    e.preventDefault();
    Pagination.page = Pagination.size;
    $(' ul.page-numbers li:last-child a').trigger('click');  
});

function scrollUp() {
    $('html, body').animate({
        scrollTop: $(".blog-section").offset().top
    }, 500);
}

jQuery.prototype.justtext = function () {
    return $(this).clone()
        .children()
        .remove()
        .end()
        .text();
};


function appendQueryString() {
    var loc = window.location.pathname;
    if (loc.indexOf('page') > 0) {
   loc = loc.replace(loc.substring(loc.indexOf('page'), loc.length), `/page/${Pagination.page}`);
    }
   else {
   loc = loc + '/page/' + Pagination.page;
   }
   loc =  loc.replace(loc, loc.replace("//", "/"));
   loc = window.location.href.replace(window.location.pathname, loc);
   window.history.pushState({path:loc}, "",loc)
}